<template>
  <component
    :is="$store.getters['auth/user'].simpleLms && [3, 6].includes(banner.type) ? 'nuxt-link' : 'div'"
    v-if="banner && banner.active"
    to="/upgrade/"
    class="banner-card"
    :class="[banner.typeName ? `${banner.typeName}-offer` : '', customCampaign.campaign, customCampaign.className, $config.project, $config.platform, { pricing, billing, extend: customCampaign.extend, 'simple-lms': $store.getters['auth/user'].simpleLms && [3, 6].includes(banner.type) }]"
  >
    <div class="content-holder">
      <div v-if="banner.iconImage || banner.image" class="icon-wrapper" :class="banner.typeName">
        <img
          v-if="banner.iconImage"
          class="banner-icon"
          :src="require (`../assets/images/banners/${banner.iconImage}`)"
        >
        <img v-if="banner.image" :src="`${$config.imagesUrl}/card-collections/${banner.image}`">
      </div>
      <div class="offer-info">
        <div v-if="!customCampaign.campaign && pricing" class="offer-type">
          {{ banner.offerType }}
        </div>
        <template v-if="$store.state.campaign === 'future-proof-2024'">
          <p v-if="pricing" class="line-1">
            Limited-Time Offer
          </p>
          <p class="line-2">
            <img src="../assets/images/campaign-future-proof/learn-future-proof.webp">
            <span class="highlight blue">
              DATA AND AI SKILLS
            </span>
            at
            <span class="highlight yellow">
              {{ customCampaign.discount }}% OFF
            </span>
          </p>
          <p class="line-3">
            Acquire the skills, knowledge, and understanding needed to thrive in an AI-driven world.<br>Get certified and ready for the future of work.
          </p>
        </template>
        <template v-else-if="$store.state.campaign === 'fast-track-2024'">
          <p v-if="pricing" class="line-1">
            Limited-Time Offer
          </p>
          <p class="line-2">
            <span class="bg-highlight" title="Fast-Track">Fast-Track</span> Your
            <span class="block">
              <span class="highlight fa-blue" title="Finance Career">FINANCE CAREER</span>
              at <span class="highlight yellow">{{ customCampaign.discount }}% OFF</span>
            </span>
          </p>
          <p class="line-3">
            Acquire the skills, knowledge, and understanding needed to thrive in an AI-driven world.<br>Get certified and ready for the future of work.
          </p>
        </template>
        <template v-if="customCampaign.campaign === 'most-wanted-2024'">
          <div class="campaign-title">
            <img v-if="customCampaign.extend && billing && $config.platform === 'fa'" class="extend-stamp" :src="require(`../assets/images/campaigns/${$config.platform}-mw-extend.webp`)">
            <div class="line-0">
              Limited-Time Offer
            </div>
            <div class="line-1">
              Get the <span v-if="$config.platform === 'fa'">MOST</span><img :src="require(`../assets/images/campaigns/${$config.platform}-mw-title.webp`)">
            </div>
            <div class="line-2">
              <template v-if="$config.platform === 'ds'">
                <span class="highlight campaign-1">DATA</span>
                AND
                <span class="highlight campaign-2">AI</span>
                COURSES
              </template>
              <span v-else class="highlight campaign-3">FINANCE COURSES</span>
              <span class="billing-block">AT <span class="highlight campaign-3 campaign-fa-2">{{ customCampaign.discount }}% OFF</span></span>
            </div>
          </div>
          <div class="campaign-description">
            <p>
              <b v-if="$config.platform === 'ds'" class="highlight campaign-1">Grab the Annual Plan discount</b>
              <span v-else>Grab the <b>Annual Plan Discount</b></span>
              with a price-lock and money-back guarantee. Become a certified {{ $config.platform === 'ds' ? 'data scientist' : 'finance expert' }} and double your salary within a year with our practice-based, expert-led courses.
            </p>
          </div>
          <img v-if="customCampaign.extend && pricing" class="extend-stamp" :src="require(`../assets/images/campaigns/${$config.platform}-mw-extend-wide.webp`)">
        </template>
        <template v-else-if="customCampaign.campaign === 'one-of-two-hundred-2024'">
          <div class="campaign-title">
            <div class="line-1">
              GRAB <span class="highlighted">1 OF 200</span> <span>SPECIAL-PRICE</span> <span>ANNUAL PLANS</span>
            </div>
            <div class="line-2">
              Only<span class="subscriptions">{{ customCampaign.subscriptionsLeft }}</span><span class="new-line">left at this price</span>
            </div>
          </div>
          <div class="campaign-description">
            <p>Get your annual plan today because the price won't be the same tomorrow.</p>
            <p>Start learning at the best cost and get a price-lock guarantee.</p>
          </div>
        </template>
        <template v-else-if="customCampaign.campaign === 'transform-your-future-2024'">
          <div class="line-0">
            Limited-Time Offer
          </div>
          <div class="line-1">
            <span class="highlight campaign-1">TRANSFORM</span> <span class="bigger">Your</span> <b>FUTURE</b>
          </div>
          <div class="line-2">
            <span class="bigger">with</span> <b>{{ $config.platform === 'ds' ? 'Data and AI Skills' : 'In-Demand Finance Skills' }}</b><br class="mobile-only"> at <span class="highlight campaign-2">72% OFF</span>
          </div>
          <div class="line-3">
            <b class="highlight campaign-1">Make your 2024 count!</b> Kickstart your dream career with in-demand {{ $config.platform === 'ds' ? 'data and AI skills' : 'finance skills' }}. Start your life-changing journey today with a 365 Annual Plan at 72% off.
          </div>
        </template>
        <template v-else-if="customCampaign.campaign === 'cyber-monday-2023'">
          <div class="line-1">
            <template v-if="!customCampaign.extend">
              Limited-Time Offer
            </template>
            <template v-else>
              <div v-show="$store.state.layout === 'desktop'" class="ext-label" style="--ratio: calc(208 / 91);">
                <img :src="require(`../assets/images/campaign-cyber-monday-2023/cm-ext-label.webp`)">
              </div>
              <div v-show="$store.state.layout === 'mobile'" class="ext-label" style="--ratio: calc(215 / 136);">
                <img :src="require(`../assets/images/campaign-cyber-monday-2023/cm-ext-label-mobile.webp`)">
              </div>
            </template>
          </div>
          <div class="line-2">
            <strong>CYBER MONDAY</strong> OFFER
          </div>
          <div class="img">
            <img v-show="$store.state.layout === 'desktop'" class="title-inline" :src="require(`../assets/images/campaign-cyber-monday-2023/${$config.platform}-cm-title-hero2.webp`)">
            <img v-show="$store.state.layout === 'mobile'" class="title-inline" :src="require(`../assets/images/campaign-cyber-monday-2023/${$config.platform}-cm-title-hero-mobile.webp`)">
          </div>
          <div class="line-3">
            Grab a Premium Annual Plan at <strong>72% OFF</strong> the standard price – including all current and upcoming content and features. Study all year round and renew at the same cost next year with our price-lock guarantee.
          </div>
        </template>
        <template v-else-if="customCampaign.campaign === 'black-friday-2023'">
          <div class="line-1">
            Limited-Time Offer
          </div>
          <div class="line-2">
            <strong>BLACK FRIDAY</strong> OFFER
          </div>
          <div class="img">
            <img v-show="$store.state.layout === 'desktop'" class="title-inline" :src="require(`../assets/images/campaign-black-friday-2023/${$config.platform}-bf-title-hero.webp`)">
            <img v-show="$store.state.layout === 'mobile'" class="title-inline" :src="require(`../assets/images/campaign-black-friday-2023/${$config.platform}-bf-title-hero-mobile.webp`)">
          </div>
          <div class="line-3">
            Grab a Premium Annual Plan at 72% OFF the standard price – including all current and upcoming content and features. Study all year round and renew at the same cost next year with our price-lock guarantee.
          </div>
        </template>
        <template v-if="customCampaign.campaign === 'free-weeks-2023'">
          <p class="line-1">
            Limited-Time Offer
          </p>
          <template v-if="$config.platform === 'ds' && $config.project === 'lms'">
            <p class="line-2">
              <span class="highlight blue">ALL DATA</span> <span class="mobile-block">and <span class="highlight yellow">AI COURSES</span></span>
            </p>
            <p class="line-3">
              <span class="highlight-special">FREE</span>
            </p>
            <p class="line-4">
              Great news! Your Free Plan was automatically upgraded as part of our free initiative. We’re giving you unlimited access to the entire 365 platform through Nov. 20 at no cost. After the offer expires, your subscription will be reverted to the standard free package.
            </p>
          </template>
          <template v-else-if="$config.platform === 'ds' && $config.project === 'site'">
            <p class="line-2">
              MASTER <span class="highlight blue">FUTURE-PROOF</span>
            </p>
            <p class="line-3">
              <span class="highlight yellow">DATA</span> and <span class="highlight yellow">AI SKILLS</span> for <span class="highlight-special">FREE</span>
            </p>
            <p class="line-4">
              Gain unlimited access to the full 365 platform through November 20. Register with a Free Plan now—no credit card required. Existing Free Plan users will be automatically upgraded. After November 20, their access will be reverted to the standard free package.
            </p>
          </template>
          <template v-else-if="$config.platform === 'fa' && $config.project === 'lms'">
            <p class="line-2">
              <span class="highlight yellow">ALL FINANCE <span class="mobile-block">COURSES</span></span>
            </p>
            <p class="line-3">
              <span class="highlight-special">FREE</span>
            </p>
            <p class="line-4">
              Great news! Your Free Plan was automatically upgraded as part of our free initiative. We’re giving you unlimited access to the entire 365 platform through Nov. 20 at no cost. After the offer expires, your subscription will be reverted to the standard free package.
            </p>
          </template>
          <template v-else-if="$config.platform === 'fa' && $config.project === 'site'">
            <p class="line-2">
              MASTER <span class="highlight blue">FUTURE-PROOF</span> <span class="highlight yellow mobile-block">FINANCE SKILLS</span>
            </p>
            <p class="line-3">
              <span class="small">for</span> <span class="highlight-special">FREE</span>
            </p>
            <p class="line-4">
              Gain unlimited access to the full 365 platform through November 20. Register with a Free Plan now—no credit card required. Existing Free Plan users will be automatically upgraded. After November 20, their access will be reverted to the standard free package.
            </p>
          </template>
        </template>
        <template v-else-if="$store.state.campaign === 'get-future-ready'">
          <p v-if="pricing" class="line-1">
            Limited-Time Offer
          </p>
          <p class="line-2">
            <span class="main">
              GET FUTURE-READY
            </span>
            <span class="small">WITH</span>
          </p>
          <p class="line-3">
            <span class="highlight-special" title="DATA AND">DATA AND</span>
            <span class="highlight-special" title="AI SKILLS">AI SKILLS</span>
            <span class="block">
              AT <span class="highlight">{{ customCampaign.discount }}% OFF</span>
            </span>
          </p>
          <p class="line-4">
            AI and big data skills are on the rise. Enroll in a data science program that helps you develop the practical abilities companies look for and become a sought-after candidate in the job market of tomorrow.
          </p>
        </template>
        <template v-else>
          <div v-if="[3, 6].includes(banner.type) && $store.getters['auth/user'].simpleLms" class="logo">
            <LogoPremium /> <span>Annual</span>
          </div>
          <div class="h4 offer-title" v-html="customCampaign.campaign ? customCampaign.bannerCardTitle : banner.header" />
          <div class="offer-description" v-html="customCampaign.campaign ? customCampaign.bannerCardDescription : banner.description" />
        </template>
        <CounterWithDiscount
          v-if="showCounter"
          :discount-on-left="customCampaign.counterDiscountOnLeft"
          :discount-on-right="customCampaign.counterDiscountOnRight"
          :hide-days="customCampaign.counterHideDays"
          :utc-end-date="utcEndDate"
          :discount="customCampaign.discount && !customCampaign.counterHideDiscount ? customCampaign.discount : null"
          :discount-text="customCampaign.counterDiscountText"
          :counter-class="counterClass"
        />
        <nuxt-link v-if="$store.getters['auth/user'].simpleLms && banner.type === 3" to="/upgrade/" class="btn btn-primary-yellow">
          Save 60%
        </nuxt-link>
        <nuxt-link v-if="$store.getters['auth/user'].simpleLms && banner.type === 6" to="/upgrade/" class="btn btn-primary upgrade">
          Upgrade Now
        </nuxt-link>
      </div>
    </div>
    <div v-if="[3, 2, 1].includes(banner.type) && !pricing && (!$store.getters['auth/user'].simpleLms || ($store.getters['auth/user'].simpleLms && banner.type !== 3))" class="plan-card-holder">
      <PlanCard :plan="plan" :campaign="new Date(customCampaign.lastEndDate) > new Date() ? $store.state.campaign : ''" type="upgrade" />
    </div>
    <img
      v-if="hasBackgroundImage"
      class="bg-image"
      :src="$store.state.layout === 'desktop' || $store.state.tablet ? bannerBackground.desktop : bannerBackground.mobile"
    >
  </component>
</template>

<script>
import PlanCard from '../Pricing/PlanCard';
import CounterWithDiscount from '../CounterWithDiscount';
import LogoPremium from '../assets/svg/365-logo-premium2.svg?vue-component';

export default {
  components: { PlanCard, CounterWithDiscount, LogoPremium },
  props: {
    banner: { type: Object, required: true, default: () => ({}) },
    customCampaign: { type: Object, required: false, default: () => ({}) },
    plan: { type: Object, required: false, default: () => ({}) },
    pricing: { type: Boolean, required: false },
    billing: { type: Boolean, required: false },
    counter: { type: Boolean, required: false },
  },
  data() {
    return {
      iconWrapperClasses: {
        3: 'collection',
        4: 'referral',
        5: 'loyalty',
      },
    };
  },
  computed: {
    iconWrapperClass() {
      return this.iconWrapperClasses[this.banner.type];
    },
    hasBackgroundImage() {
      return this.banner.typeName === 'trigger';
    },
    bannerBackground() {
      if (this.pricing) {
        return {
          desktop: require('../assets/images/banners/technologies-bg-pricing.png'),
          mobile: require('../assets/images/banners/technologies-bg-mobile-pricing.png'),
        };
      }
      return {
        desktop: require('../assets/images/banners/technologies-bg.png'),
        mobile: require('../assets/images/banners/technologies-bg-mobile.png'),
      };
    },
    utcEndDate() {
      if (this.customCampaign.campaign === 'most-wanted-2024' && this.customCampaign.lastEndDate) {
        return new Date(this.customCampaign.lastEndDate);
      }

      return new Date(this.customCampaign.endDate || this.banner.countDownDate);
    },
    showCounter() {
      if (['black-friday-2023', 'cyber-monday-2023', 'future-proof-2024', 'fast-track-2024'].includes(this.customCampaign.campaign) && this.billing) {
        return false;
      }

      if (typeof this.customCampaign.counter !== 'undefined') {
        return this.customCampaign.counter;
      }

      if (this.banner.type === 3 && this.$store.getters['auth/user'].simpleLms) {
        return true;
      }

      return (this.pricing && (this.banner.type === 1 || this.banner.type === 2 || this.banner.type === 3));
    },
    counterClass() {
      if (['future-proof-2024', 'fast-track-2024'].includes(this.customCampaign.campaign)) {
        return 'filled no-border';
      }

      return 'cfp cfp-pricing';
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-card {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-32);
  border-radius: 20px;
  margin-bottom: var(--spacing-16);
  z-index: 1;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    border-radius: 20px;
    border: 10px solid rgba(255, 255, 255, 0.3);
    z-index: 0;
  }

  &.simple-lms.collection-offer:after {
    content: '';
    position: absolute;
    width: unset;
    height: unset;
    border: unset;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: 20px;
    padding: 10px; /* Вътрешен отстъп за създаване на вътрешен бордър */
    background: linear-gradient(135deg, #EDC843 0%, #FF5050 50%, #7B61FF 100%);
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
    z-index: -1;
  }

  &.simple-lms.billing.collection-offer:after {
    background: linear-gradient(135deg, rgba(237, 200, 67, 1) 0%, rgba(255, 80, 80, 0.9) 30%, rgba(123, 97, 255, 0.5) 100%);
  }

  > * {
    z-index: 1;
  }

  .icon-wrapper {
    max-width: 64px;
    width: 100%;
    height: 64px;
    border-radius: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &.referral {
      background: linear-gradient(135deg, #68A9FE 1.25%, #4321A4 98.75%);
      border: 2px solid var(--accent-light-2);

      .banner-icon {
        mix-blend-mode: luminosity;
      }
    }

    &.loyalty {
      background: #011633;
      border: 2.4px solid #CDE2FF;
    }

    &.collection {
      border: 2.4px solid var(--main-yellow-light-1);
    }

    .banner-icon {
      display: block;
      max-width: 100%;
    }
  }

  .offer-title {
    font-weight: 600;
    font-size: 28px;
    line-height: 34px;
    margin-bottom: var(--spacing-8);
  }

  .offer-description {
    margin: 0;
    line-height: 26px;
  }

  .plan-card-holder {
    .plan-card-wrapper {
      margin: 0;
    }
  }

  &.loyalty-offer {
    background: linear-gradient(93.46deg, #358CFD -7.77%, #0259CA 109.14%);

    .content-holder {
      display: flex;
      flex-direction: row;
      column-gap: 24px;

      .offer-info {
        color: var(--main-light);

        ::v-deep .offer-title {
          font-weight: 600;

          .highlighted {
            font-weight: 800;
          }
        }

        ::v-deep .offer-description .highlighted {
          font-weight: 700;
        }
      }
    }
  }

  &.referral-offer {
    background: linear-gradient(134.23deg, #8CDAE3 0.65%, #B8BFFF 99.35%);

    .content-holder {
      display: flex;
      flex-direction: row;
      column-gap: 24px;
      color: #10141C;

      ::v-deep .offer-title {
        .highlighted {
          color: #4321A4;
          font-weight: 900;
        }
      }

      ::v-deep .offer-description .highlighted {
        font-weight: 700;
      }
    }
  }

  &.collection-offer {
    padding: var(--spacing-28) var(--spacing-32) var(--spacing-28) var(--spacing-50);
    background: linear-gradient(142.13deg, #FAE391 -20.32%, #7B61FF 128.3%);

    .content-holder {
      margin-right: 38px;
      max-width: 570px;

      .icon-wrapper img {
        display: block;
        width: 100%;
      }

      .offer-info {
        margin-top: var(--spacing-20);

        ::v-deep .offer-title {
          .highlighted {
            font-weight: 700;
            color: var(--main-purple-dark-1);
          }
        }

        ::v-deep .offer-description .highlighted {
          font-weight: 700;
        }
      }
    }

    .plan-card-holder {
      z-index: 1;
    }
  }

  &.simple-lms {
    justify-content: flex-start;

    &:not(.pricing) {
      color: var(--main-light);
      background-image: url(../assets/images/simple-lms-banner-bg.jpg);
      background-position: right;
      background-repeat: no-repeat;
      background-color: var(--main-dark);

      .content-holder {
        .offer-info {
          max-width: 480px;
        }

        ::v-deep .counter-with-discount {
          justify-content: flex-start;
        }
      }
    }

    &.pricing {
      background: var(--main-dark);

      .offer-type {
        display: none;
      }

      .content-holder {
        .offer-info {
          .logo {
            span {
              display: none;
            }
          }

          ::v-deep {
            .offer-description,
            .offer-title {
              color: var(--main-light) !important;
            }
          }

          .btn-primary-yellow,
          .upgrade {
            display: none;
          }
        }
      }
    }

    &.fa:not(.pricing) {
      background-image: url(../assets/images/simple-lms-banner-bg-fa.jpg);
    }

    .icon-wrapper {
      display: none;
    }

    .content-holder {
      .offer-info {
        .logo {
          font-size: 21px;
          font-weight: 600;
          line-height: 21px;

          span {
            margin-left: 4px;
          }
        }

        ::v-deep {
          .offer-title {
            margin: var(--spacing-24) 0;

            .highlighted {
              color: var(--main-yellow);
              text-transform: uppercase;
            }
          }

          .offer-description {
            margin-bottom: var(--spacing-32);
          }
        }
      }

      ::v-deep .counter-with-discount {
        margin: var(--spacing-32) 0;

        .square {
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.20);

          &:before {
            content: none;
          }
        }
      }

      .btn-primary-yellow {
        min-width: 180px;
        color: var(--main-dark);
      }

      .upgrade {
        background: linear-gradient(294deg, #7B61FF -4.18%, #FF5050 50.73%, #EDC843 120.38%);
        border-color: transparent;
        box-shadow: 0px 4px 15px 0px rgba(0, 12, 31, 0.25);
        font-weight: 600;
        color: var(--main-light);
        height: 40px;
        line-height: 40px;
        min-width: 180px;
        padding: 0;
      }
    }
  }

  &.trigger-offer {
    background: linear-gradient(90deg, #7B61FF -22.63%, #FF5050 72.55%, #FAE391 138.04%);
    padding: var(--spacing-28) var(--spacing-32) var(--spacing-28) var(--spacing-50);
    position: relative;
    color: var(--main-light);
    overflow: hidden;

    .content-holder {
      max-width: 570px;
      margin-right: 38px;
      z-index: 1;

      .offer-info {
        ::v-deep .offer-title {
          margin-bottom: var(--spacing-12);

          .highlighted {
            font-weight: 800;
          }
        }

        ::v-deep .offer-description {
          font-weight: 500;

          .highlighted {
            font-weight: 700;
          }
        }
      }
    }

    .plan-card-holder {
      z-index: 2;
    }

    .bg-image {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      mix-blend-mode: luminosity;
    }

    &.pricing {
      background: linear-gradient(90deg, #7B61FF -22.71%, #FF5050 67.63%, #FAE391 129.79%);

      .content-holder {
        .offer-type {
          margin-bottom: var(--spacing-8);
        }

        .offer-title {
          margin-bottom: var(--spacing-8);
          line-height: 35px;
        }

        ::v-deep .counter {
          margin-top: 9px;

          .square {
            &:not(:last-of-type):after,
            span,
            p {
              color: var(--main-red-light-2);
            }
          }
        }
      }
    }
  }

  &.pricing {
    max-width: 876px;
    margin: 54px auto;
    padding: var(--spacing-32);

    .content-holder {
      max-width: 100%;
      margin: 0;

      .offer-type {
        font-weight: 700;
        font-size: 18px;
        line-height: 110%;
      }

      ::v-deep .counter {
        width: 293px;
        margin: 0 auto;

        .square {
          width: 56px;
          height: 58px;
          padding: 0;
          border: none;
          position: relative;

          &:not(:last-of-type):after {
            content: ':';
            font-size: 32px;
            line-height: 100%;
            position: absolute;
            top: 11px;
            right: -8px;
          }

          span {
            font-weight: 500;
            height: 34px;

            &.number {
              font-size: 28px;
            }

            &.display-text {
              font-weight: 500;
              font-size: 14px;
              height: 23px;
            }
          }
        }
      }
    }

    &.loyalty-offer {
      .content-holder {
        column-gap: 12px;

        .offer-info {
          text-align: left;

          .offer-type {
            color: #CDE2FF;
            margin-bottom: var(--spacing-8);
          }
        }
      }
    }

    &.collection-offer {
      padding: var(--spacing-32) 76px;

      .content-holder {
        display: flex;
        flex-direction: column;
        align-items: center;

        .icon-wrapper img {
          display: block;
          width: 100%;
        }

        .offer-info {
          margin-top: var(--spacing-14);

          .offer-type {
            margin-bottom: var(--spacing-12);
            color: var(--main-purple-dark-1);
          }

          ::v-deep .offer-title {
            margin-bottom: var(--spacing-12);

            .highlighted {
              font-weight: 800;
            }
          }

          .offer-description {
            color: #10141C;
            margin-bottom: var(--spacing-12);
          }

          ::v-deep .counter {
            .square {
              color: var(--main-purple-shade-2);

              &:after {
                top: 0;
              }

              span.number {
                line-height: 34px;
              }
            }
          }
        }
      }
    }

    &.referral-offer {
      .content-holder {
        .offer-info {
          text-align: left;

          .offer-type {
            color: var(--main-purple-dark-1);
            margin-bottom: var(--spacing-8);
          }
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .banner-card {
    .offer-title {
      font-size: 24px;
      line-height: 30px;
    }

    &.pricing {
      max-width: 711px;
    }

    &.collection-offer {
      &.billing .content-holder {
        margin-right: var(--spacing-lg);
      }
    }

    &.loyalty-offer {
      &.billing .content-holder {
        .offer-title {
          line-height: 34px;
          font-size: 28px;
        }
      }
    }

    &.referral-offer {
      &.billing .content-holder {
        .offer-title {
          line-height: 34px;
          font-size: 28px;
        }
      }
    }

    &.trigger-offer {
      &.pricing .content-holder .offer-title {
        line-height: 30px;
      }

      &.billing .content-holder {
        margin-right: var(--spacing-lg);

        .offer-title {
          margin-right: var(--spacing-100);
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .banner-card {
    &.trigger-offer,
    &.collection-offer {
      padding: var(--spacing-32);
      justify-content: space-between;

      .content-holder {
        max-width: 100%;
      }

      @media screen and (max-width: 750px) {
        flex-direction: column;

        .content-holder {
          max-width: 100%;
          margin: 0 0 var(--spacing-32);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .offer-title,
          .offer-description {
            text-align: center;
          }
        }

        .plan-card-holder {
          width: 100%;

          .plan-card-wrapper {
            max-width: 100%;

            ::v-deep .plan-card {
              .counter {
                width: 100%;
                max-width: 100%;
              }

              .footer button {
                height: 54px;
                max-width: 100%;
                width: 100%;
              }
            }
          }
        }
      }
    }

    &.pricing {
      max-width: 100%;
    }

    &.simple-lms.billing {
      background-position: 94% top;
      background-size: auto 370px;

      .offer-info {
        padding-top: 370px;

        .logo {
          &:before {
            content: '';
            width: 93%;
            height: 68px;
            background: linear-gradient(0deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.00) 100%);
            position: absolute;
            top: 303px;
            left: 10px;
          }
        }

        .btn {
          width: 100%;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &.collection-offer:after {
        background: linear-gradient(180deg,  rgba(237, 200, 67, 0.7) 0%, rgba(255, 80, 80, 0.9) 60%, rgba(123, 97, 255, 1) 100%);
      }
    }
  }
}

@include bp($bp-phone) {
  .banner-card {
    &.loyalty-offer,
    &.referral-offer {
      .content-holder {
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .offer-info {
          text-align: center;
        }
      }
    }

    &.loyalty-offer {
      .content-holder {
        row-gap: 20px;

        .offer-info {
          .offer-title {
            padding: 0 var(--spacing-16);
            margin-bottom: var(--spacing-12);
          }
        }
      }

      &.pricing {
        padding: var(--spacing-32);
      }
    }

    &.referral-offer {
      .content-holder {
        row-gap: 16px;
      }

      &.pricing {
        padding: var(--spacing-32);
      }
    }

    &.collection-offer {
      background: linear-gradient(142.13deg, #FAE391 -20.32%, #7B61FF 128.3%);
      padding: var(--spacing-32) var(--spacing-24);
      flex-direction: column;

      .content-holder {
        padding: 0 var(--spacing-8);
      }
    }

    &.trigger-offer {
      padding: var(--spacing-32) var(--spacing-24);
      background: linear-gradient(180deg, #7B61FF -1.2%, #FF5050 75.54%, #FAE391 128.35%);

      .content-holder {
        padding: 0 var(--spacing-8);

        .offer-info {
          ::v-deep .offer-title {
            line-height: 35px;
            margin-bottom: var(--spacing-8);
          }
        }
      }

      .bg-image {
        width: 100%;
        height: auto;
      }

      &.pricing {
        background: linear-gradient(90deg, #7B61FF -36.09%, #FF5050 64.09%, #FAE391 133.03%);
        padding: var(--spacing-32);

        .content-holder {
          padding: 0;
          margin: 0;

          .offer-title {
            margin-bottom: var(--spacing-12);
            padding: 0 var(--spacing-4);
          }

          ::v-deep .counter {
            width: 100%;
            margin-top: var(--spacing-12);
          }
        }
      }

      &.billing .content-holder .offer-title {
        padding: 0 var(--spacing-4);
      }
    }

    &.pricing {
      &.loyalty-offer,
      &.referral-offer,
      &.collection-offer,
      &.trigger-offer {
        .content-holder {
          .offer-info {
            text-align: center;
          }
        }
      }

      &.collection-offer {
        padding: var(--spacing-32);

        .content-holder {
          padding: 0;
          width: 100%;

          .offer-info {
            max-width: 100%;

            ::v-deep .counter {
              width: 100%;

              .square {
                width: auto;
              }
            }
          }
        }
      }
    }
  }
}

.fa {
  @import '../assets/sass/fa/components/banner-card.scss';
}

.future-proof-2024,
.fast-track-2024 {
  @import '../assets/sass/ds/components/fp-banner-card.scss';
}

.most-wanted-2024 {
  @import '../assets/sass/ds/components/mw-banner-card.scss';
}
</style>
